document.addEventListener('DOMContentLoaded', function () {
  const urlParams = window.location.search;
  const clickId = getClickId(urlParams);

  if (clickId) {
    const existingQueryString = getCookie('affiliate_query');
    if (!existingQueryString || !existingQueryString.includes(clickId)) {
      setCookie('affiliate_query', urlParams, 30);
    }
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  function getCookie(name) {
    const cookies = `; ${document.cookie}`.split(`; ${name}=`);
    return cookies.length === 2 ? cookies.pop().split(';').shift() : null;
  }

  function getClickId(queryString) {
    const match = queryString.match(/click_id=([^&]*)/);
    return match ? match[1] : null;
  }

  if (window.location.pathname === '/cart') {
    const queryString = getCookie('affiliate_query');

    if (queryString) {
      const queryParams = queryString.substring(1); // Remove the '?' from the start
      const keyValuePairs = queryParams.split('&').map((param) => {
        const [key, value] = param.split('=');
        return { name: key, value: decodeURIComponent(value) };
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: keyValuePairs.reduce((acc, param) => {
            acc[param.name] = param.value;
            return acc;
          }, {}),
        }),
      })
        .then((response) => response.json())
        .then((data) => console.log('Cart updated:', data))
        .catch((error) => console.error('Error:', error));
    }
  }
});